export * from './mating-animal-table.component';
export * from './mating-birth-table.component';
export * from './mating-plug-date-table.component';
